import { cookieUtils } from '@fishx/utils';

const { getCookie, setCookie } = cookieUtils;

interface LangMap {
  [name: string]: string;
}

const LangMap: LangMap = {
  zh: 'zh-CN',
  en: 'en-US',
  es: 'es-ES',
  id: 'id-ID',
};

const getInitLocale = (defaultLocale: string|undefined) => {
  // 服务器应返回当前请求ip所在区域，并设置在cookie里
  // 优先获取用户选择的语言
  let locale: any = getCookie('userLocale');

  // 兼容可能只传了国家的情况，比如只传了 zh 或者 cn
  if (locale) {
    const [country = '', lang = ''] = locale.split('-');
    if (country !== '' && lang === '') {
      locale = LangMap[country];
    }
  }

  if (!locale) {
    // 如果用户没有选择语言，获取服务器返回的区域语言
    locale = getCookie('areaLocale');
  }
  if (!locale) {
    // 集成到uportal里面有这个 值为：en/en_US 和 zh/zh_CN
    locale = getCookie('ZSMART_LOCALE');
    if (['en', 'en_US'].includes(locale)) {
      locale = 'en-US';
    }
    if (['zh', 'zh_CN'].includes(locale)) {
      locale = 'zh-CN';
    }
    if (['es', 'es_ES'].includes(locale)) {
      locale = 'es-ES';
    }
    if (['id', 'id_ID'].includes(locale)) {
      locale = 'id-ID';
    }
  }

  if (!locale) {
    const query = window.location.search.substring(1);
    query.split('&').forEach(v => {
      const pair = v.split('=');
      if (pair[0] === 'locale') {
        locale = pair[1];
      }
    });
  }

  if (!locale) {
    locale = window.localStorage.getItem('fishx_locale');
  }

  (window as any).locale = locale;
  const defaultLang = locale || defaultLocale || 'zh-CN';
  window.localStorage.setItem('fishx_locale', defaultLang);
  if (getCookie('userLocale')) {
    setCookie('userLocale', defaultLang, 'd30');
  } else if(getCookie('areaLocale')) {
    setCookie('areaLocale', defaultLang, 'd30');
  } else if (getCookie('ZSMART_LOCALE')) {
    setCookie('ZSMART_LOCALE', defaultLang, 'd30');
  }
  return defaultLang;
};

export default getInitLocale;
